module.exports = __webpack_public_path__ + "img/_marked.91eadb51.svg";